import styles from "./styles.module.scss";
import { useState, useEffect } from "react";
import useAppContext from "../../AppContext";
import { COACHING_STYLE } from "../../../config/tags";
import SiteWrapper from "../../SiteWrapper";
import { fetchCoaches } from "../../../utils/assessment";
import { Carousel } from "@ww-digital/prism";
import t from "../../../utils/translate";

export default function Coaches() {
  const [coaches, setCoaches] = useState([]);
  const { assessment, answers } = useAppContext();
  const coachQuestions = assessment.questions
    .filter(q => q.tags.includes(COACHING_STYLE))
    .map(q => q?._id);

  const answerNeeded = coachQuestions
    ? answers?.find(a => coachQuestions.includes(a?.questionId))
    : null;

  useEffect(() => {
    if (coachQuestions && answerNeeded) {
      const userCoachStyles = answerNeeded.answers.map(selection => {
        return selection.text.toLowerCase();
      });
      fetchCoaches(userCoachStyles).then(fetchedCoaches => {
        setCoaches(fetchedCoaches.data);
      });
    }
  }, [answerNeeded]);
  if (!coachQuestions || !answerNeeded) return null;

  const carouselItems = coaches.map((coach, i) => {
    return {
      children: (
        <div
          className={styles.coach}
          key={i}
          da-catgory="quiz"
          da-action="coach_card"
          da-label="quiz:coach_card"
        >
          <img src={coach.profilePictureURL} alt="" />
          <div className={styles.bio}>
            <h2>{coach.displayName}</h2>
            <p>{coach.bio}</p>
          </div>
        </div>
      )
    };
  });

  const options = {
    fixedWidth: "229px",
    perPage: 1,
    gap: "16px",
    arrows: false,
    mediaQuery: "min",
    type: "loop",
    breakpoints: {
      615: {
        arrows: true
      }
    }
  };

  return (
    <div className={styles.container}>
      {!coaches.length ? (
        <div>Loading...</div>
      ) : (
        <SiteWrapper size="small">
          <h1>{t("COACH_HEADER")}</h1>
          <h2>{t("COACH_SUBHEADER")}</h2>
          <Carousel
            carouselItems={carouselItems}
            options={options}
            className={styles.carousel}
          />
        </SiteWrapper>
      )}
    </div>
  );
}
